import * as React from 'react';
import { Dialog, DialogType, DialogFooter } from '@fluentui/react';
import { PrimaryButton, DefaultButton } from '@fluentui/react';
import { getId } from '@fluentui/react';
import { ContextualMenu } from '@fluentui/react';
import {TextField} from '@fluentui/react';


//const screenReaderOnly = mergeStyles(hiddenContentStyle);

export interface IDialogBasicExampleState {
    hideDialog: boolean;
    isDraggable: boolean;
}

export class ApproverDialog extends React.Component<{}, IDialogBasicExampleState> {
    state: IDialogBasicExampleState = {
        hideDialog: true,
        isDraggable: false,
        approveObject: {
            comment: null,
            costCenter: null,
            versions: this.props.versions,
            versionsDays: this.props.versionsDays
        },
        warning : false,
        isDisabled: false
    };
    // Use getId() to ensure that the IDs are unique on the page.
    // (It's also okay to use plain strings without getId() and manually ensure uniqueness.)
    _labelId: string = getId('dialogLabel');
    _subTextId: string = getId('subTextLabel');
    _dragOptions = {
        moveMenuItemText: 'Move',
        closeMenuItemText: 'Close',
        menu: ContextualMenu
    };


    onWriteEvent (e,v) {
        if(v.length > 0)
        {
            this.setState({warning: false})
        }
      
        this.setState({
            approveObject: {
                ...this.state.approveObject,
                comment: v 
        }});
    }

    onCostCenterWriteEvent(e,v) {
        this.setState({
            approveObject : { 
                ...this.state.approveObject,
                costCenter: v 
        }});
    }

    onVersionsWriteEvent = (e, v) => {
        this.setState({
            approveObject: {
                ...this.state.approveObject,
                versions: v
        }})
    }

    onVersionsDaysWriteEvent = (e, v) => {
        this.setState({
            approveObject: {
                ...this.state.approveObject,
                versionsDays: v === '' ? null : v
        }})
    }

    validateVersionsNumber() {
        return this.props.versions && (this.state.approveObject.versions < 1 || this.state.approveObject.versions > 500) 
            ? 'Versions number must be between 1 and 500.'
            : null
    }
    
    validateVersionsDaysNumber() {
        return this.props.versions && this.state.approveObject.versionsDays !== null && (this.state.approveObject.versionsDays < 30 || this.state.approveObject.versionsDays > 36500)
            ? 'Days number to keep versions must be between 30 and 36500 or left empty if feature should not be enabled.'
            : null
    }

    getLimitVersioningDetails() {
        return  <div style={{marginBottom: 10}}>
                    <div style={{marginBottom: 10}}>
                        <b>Set a number of versions for files stored in all document libraries on the SharePoint and approve the task. Thank you for your input and cooperation.</b>
                    </div>
                    <TextField
                        label='Type the new amount of document versions to be kept (1-500). 100 or less is recommended. If you reject setting a lower limit than 500, please write a justification.'
                        onChange={this.onVersionsWriteEvent}
                        defaultValue={this.props.versions}
                        errorMessage={this.validateVersionsNumber()}
                    />
                    <TextField
                        label='Type the number of days you would like to keep previous file versions (e.g. "180").'
                        onChange={this.onVersionsDaysWriteEvent}
                        defaultValue={this.props.versionsDays}
                        errorMessage={this.validateVersionsDaysNumber()}
                    />
                </div>
    }

    render() {
        const { hideDialog, isDraggable, isDisabled } = this.state;
        return (
            <div>
                <PrimaryButton styles={btnEditStyles} onClick={this._showDialog} text={this.props.buttonName} disabled={isDisabled} />
                <Dialog
                    maxWidth={650}
                    hidden={hideDialog}
                    onDismiss={this._closeDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: this.props.title,
                        subText: this.props.text
                    }}
                    modalProps={{
                        titleAriaId: this._labelId,
                        subtitleAriaId: this._subTextId,
                        isBlocking: false,
                        styles: { main: { maxWidth: 350 } },
                        dragOptions: isDraggable ? this._dragOptions : undefined
                    }}
                >
                    {
                        this.props.reason &&
                        <div style={purposeStyles}>
                           <div style={titleStyles}>Purpose:</div>
                           {this.props.reason} 
                        </div>
                    }
                    {
                        this.props.costCenter && 
                        <div>
                            <TextField 
                                label='Cost Center'
                                name='costCenter'
                                onChange={this.onCostCenterWriteEvent.bind(this)}
                                defaultValue={this.props.costCenter}
                            />
                        </div>
                    }
                    {
                        this.props.versions &&
                        this.getLimitVersioningDetails()
                    }
                    { this.props.additionalInfo }
                    <DialogFooter styles={{actionsRight: {textAlign: 'right', marginRight: 0}}}>
                        <PrimaryButton style={btnEditStyles} onClick={this._confirm} text={this.props.approveBtnText ? this.props.approveBtnText : "Approve"} />
                        <PrimaryButton style={{backgroundColor:'red', border: 'none'}} onClick={this._reject} text={this.props.rejectBtnText ? this.props.rejectBtnText : 'Reject'} />
                        <DefaultButton onClick={this._closeDialog} text="Cancel" />
                    </DialogFooter>
                    {
                        !this.props.hideComment && 
                        <TextField
                            label={this.props.versions ? "Please provide justification if declined." : "Required if reject*"}
                            name="Comment"
                            onChange={this.onWriteEvent.bind(this)}
                            validationResult={this.state.commentValidation}
                            multiline
                            rows={3}
                            errorMessage={this.state.warning ? "Comment required" : null}
                            styles={{root: {marginTop: 10}}}
                        />
                    }
                </Dialog>
            </div>
        );
    }

    _confirm = () : void =>
    {
        if (this.validateVersionsNumber() || this.validateVersionsDaysNumber())
            return

        this.setState({isDisabled: true})
        this.props.onApprove(this.state.approveObject);
        this._closeDialog();
    }

    _reject = (): void =>
    {
        if(!this.props.hideComment && (this.state.approveObject.comment == null || this.state.approveObject.comment.length === 0))
        {
            this.setState({warning:true})
            return;
        }

        this.setState({isDisabled: true})
        this.props.onReject(this.state.approveObject.comment);
        this._closeDialog();
    }
    
    _showDialog = (): void => {
        this.setState({ hideDialog: false });
    };

    _closeDialog = (): void => {
        this.setState({ 
            hideDialog: true,
            approveObject: {
                versions: this.props.versions,
                versionsDays: this.props.versionsDays
            }
        });
    };

    _toggleDraggable = (): void => {
        this.setState({ isDraggable: !this.state.isDraggable });
    };
}

const titleStyles = {
    fontWeight: 'bold',
    marginBottom:'3px',
}

const purposeStyles = {
    marginBottom:'8px',
    minHeight: '20px',
    overflowWrap: 'break-word'
}

const btnEditStyles = {
    root: {
        width: "100%",
        borderRadius: 0
    },
}



// WEBPACK FOOTER //
// ./src/components/ManageCenter/ApproverDialog.js